// TODO: Use the PhoneNumber component from @onegov/react-component-library
// instead of this component once the package is updated.

import { FormGroup, Input } from '@snsw/react-component-library';
import React, { useState } from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components/macro';

const Label = styled.div`
  color: #242934;
  font-weight: 500;
`;

const HelpMessage = styled.div`
  color: #646974;
  font-size: 0.875rem;
  line-height: 1.4;
  margin: 0;
  margin-bottom: -0.75rem;
`;

export const NewContactNumber = forwardRef((props, ref) => {
  const {
    id,
    name,
    helpMessage,
    allowNonNumeric = false,
    hasError,
    errorMessage,
    disabled,
    label,
    defaultValue = '',
    value: controlledValue,
    onChange,
  } = props;

  const [value, handleValueChange] = useState(props?.value || '');

  const handleNumberChange = (event) => {
    const next = event.target.value;
    const isValid = allowNonNumeric || !/\D/.test(next);

    if (isValid) {
      onChange(next);
      handleValueChange(next);
    }
  };

  {
    hasError;
  }
  {
    errorMessage;
  }

  return (
    <div ref={ref}>
      {label && <Label>{label}</Label>}
      {helpMessage && <HelpMessage>{helpMessage}</HelpMessage>}

      <FormGroup id={id} hasError={hasError} errorMessage={errorMessage} label="">
        <Input
          id={id}
          name={name}
          disabled={disabled}
          value={value}
          onChange={handleNumberChange}
          aria-label="contact number"
          inputWidth="lg"
        />
      </FormGroup>
    </div>
  );
});

NewContactNumber.displayName = 'ContactNumber';
